export const TRAP_TILTS = [4, 8, 16, 32];

export const hasModule = (type) => ['minkpolice', 'trapsensor', 'trapsensor_movement', 'tilt', 'kirrmelder', 'twin_trap'].includes(type);

export const EVENTS_DELETABLE = { trap_cleaned: true, change_battery: true, bait_changed: true,
  other: true, rotate_stick_left: true,  rotate_stick_right: true, mode_run_through: true, mode_catching: true,
  module_switch_on: true, module_switch_off: true,
  activation_expired: true, not_connected: true
};
